import { SearchObject } from "app/common/Model/SearchObject";
import { ConceptAlert } from "app/common/Model/ConceptAlert";
import {
    pagingConceptAlert,
    deleteConceptAlert,
    getConceptAlert,
    saveOrUpdate
} from 'app/services/ConceptAlertService';
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
import { checkSearchObject } from "app/common/LocalFunction";

export default class ConceptAlertStore {
    searchConceptAlert = new SearchObject()
    pageConceptAlert = null
    selectConceptAlert = null
    openConfirmDelete = false
    openFormCreateOrEdit = false

    constructor() {
        makeAutoObservable(this);
    }

    pagingConceptAlert = async() => {
        try {
            const {data} = await pagingConceptAlert(this.searchConceptAlert)
            this.pageConceptAlert = data
        } catch (error) {
            console.error(error);
            toast.error("Lấy dữ liệu có lỗi")
        }
    }

    saveOrUpdate = async(obj) => {
        try {
            await saveOrUpdate(obj)
            this.openFormCreateOrEdit = false
            this.pagingConceptAlert()
        } catch (error) {
            console.error(error);
            toast.error("Lưu dữ liệu có lỗi")
        }
    }

    getConceptAlert = async(id) => {
        try {
            const {data} = await getConceptAlert(id)
            this.selectConceptAlert = data
        } catch (error) {
            console.error(error);
            toast.error("Lấy dữ liệu có lỗi")
        }
    }

    handleChangeFormSearch = (searchConceptAlert) => {
        this.searchConceptAlert = checkSearchObject(this.searchConceptAlert, searchConceptAlert);
        this.pagingConceptAlert();
    }

    handleOpenFormCreateOrEdit = (id) => {
        if (Boolean(id)) {
            getConceptAlert(id).then(({ data }) => {
                this.selectConceptAlert = data;
                this.openFormCreateOrEdit = true;
            })
        } else {
            this.selectConceptAlert = new ConceptAlert();
            this.openFormCreateOrEdit = true;
        }
    }

    handleDelete = (conceptAlert) => {
        this.searchConceptAlert = { id: conceptAlert?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteConceptAlert(this.selectConceptAlert?.id)
            .then(() => {
                if (this.searchConceptAlert?.pageIndex > 1 && this.pageConceptAlert?.content?.length === 1) {
                    this.searchConceptAlert.pageIndex -= 1;
                }
                toast.success("Xóa bản ghi thành công!");
                this.handleClosePopup();
                this.pagingConceptAlert();
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa bản ghi có lỗi");
            })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    resetStore = () => {
        this.pageConceptAlert = null
        this.searchConceptAlert = new SearchObject()
        this.selectConceptAlert = null
        this.openConfirmDelete = false
        this.openFormCreateOrEdit = false
    }
}